<template>
  <div class="-wt-mass-produce-browse">
    <div class="-top">
      <div class="-desc">
        Upload a data file for the videos you wish to create.
        <br />Then select any record to create a sample video.
      </div>
      <div class="-right">
        <div class="-upload">
          <input
            v-show="false"
            type="file"
            ref="file"
            @change="$_onFile"
            accept=".csv"
          />
          <span :title="fileName" v-text="fileName" />
          <div @click="$refs.file.click()" class="-dots" title="Upload file">
            <i class="wticon wticon-dots-three-full" />
          </div>
        </div>
        <div class="-rows">
          <span v-text="fileData.numRows.toLocaleString()" /> Records
        </div>
      </div>
    </div>

    <div class="-errors" v-if="validationError" v-text="validationError" />

    <RecycleScroller
      :items="fileData.data"
      :item-size="40"
      class="-scroller"
      :class="{ '-small': !!validationError }"
      key-field="___wochitKey"
    >
      <template class="-table-header" slot="before">
        <thead>
          <tr>
            <th class="-select" v-if="fileData.fields.length">
              <div class="-radio" />
            </th>
            <th
              v-for="(field, index) in fileData.fields"
              :key="index"
              v-text="field"
              :title="field"
            />
          </tr>
        </thead>
      </template>

      <div class="-table-body" slot-scope="{ item }">
        <tr
          @click="setPreviewRowIndex(item.___wochitKey)"
          :class="{ '-highlight': previewRowIndex === item.___wochitKey }"
        >
          <td class="-select">
            <div class="-radio">
              <wt-radio-box
                group="selected-row-group"
                :selected="previewRowIndex === item.___wochitKey"
              />
            </div>
          </td>
          <td
            v-for="(field, fieldIndex) in fileData.fields"
            :key="fieldIndex"
            :title="item[field]"
            v-text="item[field]"
          />
        </tr>
      </div>
    </RecycleScroller>
  </div>
</template>

<script>
import { RecycleScroller } from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';

export default {
  data() {
    return {
      selectedRowIndex: 0,
    };
  },
  components: {
    RecycleScroller,
  },
  props: {
    validationError: {
      type: [String, Boolean],
      required: false,
    },
    fileData: {
      type: Object,
      required: true,
    },
    previewRowIndex: {
      type: Number,
      required: true,
    },
    setPreviewRowIndex: {
      type: Function,
      required: true,
    },
    onFileChange: {
      type: Function,
      required: true,
    },
    fileName: {
      type: String,
      required: true,
    },
    acceptedMimes: {
      type: Array,
      required: true,
    },
  },
  methods: {
    $_onFile: function (e) {
      e.preventDefault();
      const fileList = app.getFilesFromEvent(e);
      if (!fileList.length) {
        return;
      }
      const file = fileList[0];
      this.onFileChange(file);
    },
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
.-wt-mass-produce-browse {
  height: 100%;
  width: 100%;
  flex-direction: column;
  position: relative;

  .-top {
    display: flex;
    flex-direction: row;
    margin-bottom: 20px;
    justify-content: space-between;

    .-desc {
      width: 500px;
    }
    .-right {
      display: flex;
      flex-direction: row;
      align-items: center;
      .-upload {
        padding: 10px 65px 10px 15px;
        width: 300px;
        height: 40px;
        border: 1px solid #d9d9d9;
        font-size: 14px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        position: relative;
        .-dots {
          position: absolute;
          right: 0;
          top: 0;
          width: 40px;
          height: 40px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #ffffff;
          background-color: #06a9f4;
          i {
            font-size: 18px;
          }
        }
        margin-right: 10px;
      }
      .-rows {
        color: rgba(0, 0, 0, 0.3);
        font-size: 12px;
      }
    }
  }

  .-errors {
    margin-bottom: 20px;
    color: #d0021b;
    font-weight: 500;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .-scroller {
    height: 340px;
    position: absolute;
    width: 100%;
    border: 1px solid #d9d9d9;
    &.-small {
      height: 308px;
    }
    &/deep/ {
      .vue-recycle-scroller__slot {
        position: sticky;
        top: 0;
        height: 40px;
        z-index: 9999;
        thead {
          th {
            background: #f2f2f2;
            font-size: 14px;
            font-weight: 500;
            &.-select {
              width: 30px;
              background-color: #d9d9d9;
            }
          }
        }
      }
      .vue-recycle-scroller__item-wrapper {
        overflow: visible;
      }
    }
  }

  th,
  td {
    padding: 10px 15px;
    min-width: 280px;
    max-width: 280px;
    width: 280px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border-right: 1px solid #d9d9d9;
    border-bottom: 1px solid #d9d9d9;
    &.-select {
      box-sizing: border-box;
      padding: 0;
      min-width: 0;
      width: 30px;
      .-radio {
        width: 30px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .-table-body {
    tr {
      cursor: pointer;
      &:hover {
        background-color: rgba(0, 0, 0, 0.05);
      }
      &.-highlight {
        background-color: rgba(6, 169, 244, 0.2);
      }
    }
  }
}
</style>
